import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Box, Button, TextField, Modal } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import toast from 'react-hot-toast';
import LeadService from '../../core/services/leadsService';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

const optionsImportForm = [
    { label: 'Lofty', value: 'lofty' },
    { label: 'Kuvcore', value: 'kuvcore' },
];
const apiKey = 'AIzaSyDj4s0gSPvrFI1xBvGGBAijVoluwpAhQyA';
const AddSingleContact = ({ setOpenImportContact }) => {
    const [openContact, setOpenContact] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [options, setOptions] = useState([]);
    const [inputAddress, setInputAddress] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [lastName, setLastName] = useState('');
    const [leadSource, setLeadSource] = useState('');
    const [leadType, setLeadType] = useState('');
    const [zipCode, setZipCode] = useState('');
    const geocoder = useRef(null);
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [importFormState, setImportFormState] = useState('');
    const autocompleteService = useRef(null);
    const isFetching = useRef(false); // To prevent redundant fetches for the same input

    useEffect(() => {
        if (!window.google && apiKey) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
            script.async = true;
            script.onload = () => initializeServices();
            script.onerror = () => console.error('Failed to load Google Maps JavaScript API.');
            document.body.appendChild(script);
        } else {
            initializeServices();
        }
    }, [apiKey]);

    const initializeServices = () => {
        if (window.google) {
            if (!autocompleteService.current) {
                autocompleteService.current = new window.google.maps.places.AutocompleteService();
            }
            if (!geocoder.current) {
                geocoder.current = new window.google.maps.Geocoder();
            }
        }
    };

    const handleInputChange = (event) => {
        const value = event.target.value;
        setInputAddress(value);
        setOptions([]);
        if (!value || !autocompleteService.current || isFetching.current) {
            return;
        }
        isFetching.current = true;
        autocompleteService.current.getPlacePredictions({ input: value }, (predictions) => {
            if (predictions) {
                setOptions(
                    predictions.map((prediction) => ({
                        description: prediction.description,
                        place_id: prediction.place_id,
                    }))
                );
            } else {
                setOptions([]);
            }
            isFetching.current = false;
        });
    };

    const handlePlaceSelect = (placeId) => {
        if (!geocoder.current) return;
        geocoder.current.geocode({ placeId }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const addressComponents = results[0].address_components;
                const cityComponent = addressComponents.find((comp) => comp.types.includes('locality'));
                const stateComponent = addressComponents.find((comp) => comp.types.includes('administrative_area_level_1'));
                setCity(cityComponent ? cityComponent.long_name : '');
                setState(stateComponent ? stateComponent.long_name : '');

                // Extract latitude and longitude
                const location = results[0].geometry.location;
                setLatitude(location.lat());
                setLongitude(location.lng());
            } else {
                console.error('Geocode was not successful for the following reason: ' + status);
            }
        });
    };

    // Handler for when an option is selected
    const handleChangeImportFrom = (event, newValue) => {
        setImportFormState(newValue ? newValue.value : '');
    };
    const handleOpenContact = () => {
        setOpenContact(true);
        // setOpenImportContact(false)
    };
    const handleCloseContact = () => {
        setOpenContact(false);
        setOptions([]);
        setInputAddress('');
        setName('');
        setEmail('');
        setPhone('');
        setLastName('');
        setLeadSource('');
        setLeadType('');
        setZipCode('');
        setCity('');
        setState('');
        setLatitude('');
        setLongitude('');
        setImportFormState('');
    };

    const handleSaveChange = async () => {
        if (!name) {
            return toast.error('First name is required');
        }
        if (!lastName) {
            return toast.error('Last name is required');
        }
        if (!inputAddress) {
            return toast.error('Property address is required');
        }
        if (!city) {
            return toast.error('City is required');
        }
        if (!state) {
            return toast.error('State is required');
        }
        if (!zipCode) {
            return toast.error('Zip code is required');
        }
        if (!email) {
            return toast.error('Email is required');
        }
        if (!phone) {
            return toast.error('Phone number is required');
        }
        if (!leadSource) {
            return toast.error('Lead source is required');
        }
        if (!leadType) {
            return toast.error('Lead type is required');
        }
        if (!importFormState) {
            return toast.error('Import source is required');
        }
        try {
            setLoading(true);
            const res = await LeadService.IcaCreateContact(
                name,
                lastName,
                email,
                phone,
                leadSource,
                leadType,
                inputAddress,
                city,
                state,
                importFormState,
                zipCode,
                latitude,
                longitude
            );
            if (res.data.success) {
                toast.success(res.data.message);
                setOptions([]);
                setInputAddress('');
                setName('');
                setEmail('');
                setPhone('');
                setLastName('');
                setLeadSource('');
                setLeadType('');
                setZipCode('');
                setCity('');
                setState('');
                setLatitude('');
                setLongitude('');
                setImportFormState('');
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setOpenContact(false);
            setLoading(false);
        }
    };
    return (
        <div>
            <Button
                onClick={handleOpenContact}
                sx={{
                    width: '350px',
                    height: '50px',
                    backgroundColor: '#a19a9a70',
                    fontWeight: '500',
                    borderRadius: '12px',
                    color: 'black',
                    fontSize: '16px',
                    textTransform: 'none',
                    fontFamily: "'Poppins', sans-serif",
                    '&:hover': {
                        backgroundColor: '#a19a9a70',
                    },
                }}
            >
                Add Single Contact
            </Button>

            <Dialog
                PaperProps={{
                    sx: {
                        width: '580px',
                        maxWidth: '100%',
                    },
                }}
                open={openContact}
                aria-labelledby="edit-profile-dialog-title"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="edit-profile-dialog-title">
                    Add Single Contact
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseContact}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '16px',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <TextField
                            fullWidth
                            id="name"
                            name="name"
                            label="First Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                                width: '490px',
                            }}
                        />
                        <TextField
                            fullWidth
                            id="last_name"
                            name="last_name"
                            label="Last name"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                                width: '490px',
                            }}
                        />
                        <Autocomplete
                            freeSolo
                            options={options.map((option) => option.description)}
                            onInputChange={(event, value) => setInputAddress(value)}
                            onChange={(event, value) => {
                                const selectedOption = options.find((option) => option.description === value);
                                if (selectedOption) {
                                    handlePlaceSelect(selectedOption.place_id);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Property Address"
                                    variant="outlined"
                                    value={inputAddress}
                                    onChange={handleInputChange}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                        }
                                    }}
                                    sx={{ width: '490px' }}
                                />
                            )}
                        />
                        <TextField label="City" variant="outlined" value={city} onChange={(e) => setCity(e.target.value)} sx={{ width: '490px' }} />
                        <TextField
                            label="State"
                            variant="outlined"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            sx={{ width: '490px' }}
                        />
                        <TextField
                            label="zip"
                            variant="outlined"
                            value={zipCode}
                            onChange={(e) => setZipCode(e.target.value)}
                            sx={{ width: '490px' }}
                        />
                        <TextField
                            fullWidth
                            id="email"
                            name="email"
                            label="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            // inputProps={{
                            //     readOnly: true,
                            // }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                                width: '490px',
                            }}
                        />
                        <TextField
                            fullWidth
                            id="phone"
                            name="phone"
                            label="Phone #"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                                width: '490px',
                            }}
                        />
                        <TextField
                            fullWidth
                            id="lead_source"
                            name="lead_source"
                            label="Lead Source"
                            value={leadSource}
                            onChange={(e) => setLeadSource(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                                width: '490px',
                            }}
                        />
                        <TextField
                            fullWidth
                            id="lead_type"
                            name="lead_type"
                            label="Lead Type"
                            value={leadType}
                            onChange={(e) => setLeadType(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                                width: '490px',
                            }}
                        />
                        <Autocomplete
                            disablePortal
                            options={optionsImportForm}
                            getOptionLabel={(a) => a.label} // How the label should be displayed
                            sx={{ width: '490px' }}
                            onChange={handleChangeImportFrom}
                            renderInput={(params) => <TextField {...params} label="Import From" />}
                            value={optionsImportForm?.find((a) => a.value === importFormState) || null}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                        onClick={handleSaveChange}
                        sx={{
                            width: '490px',
                            height: '40px',
                            backgroundColor: '#587dbf',
                            fontWeight: '500',
                            borderRadius: '12px',
                            border: '1px solid #587dbf',
                            color: 'white',
                            fontSize: '16px',
                            textTransform: 'none',
                            fontFamily: "'Poppins', sans-serif",
                            '&:hover': {
                                backgroundColor: '#587dbf',
                            },
                        }}
                        disabled={Loading}
                    >
                        {Loading ? <span style={{ color: 'white' }}>Loading...</span> : 'Submit'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default AddSingleContact;
